<template>
  <div class="d-inline-block">
    <b-button variant="outline-primary" :size="size" @click="showModal = true">
      <i class="fa fa-fw fa-chart-line"></i>
      Amilia
    </b-button>
    <b-modal :title="trans('amilia_financial_reports')" v-model="showModal" hide-footer>
      <p>{{ trans('amilia_financial_reports_about') }}</p>
      <b-row>
        <b-col>
          <p>
            <a :href="beakdownOfSalesUrl" target="_blank" class="btn btn-outline-primary">
              <i class="fa fa-fw fa-file-excel"></i>
              {{ trans('amilia_sales_breakdown') }}
            </a>
          </p>
          <p>
            <a :href="salesSummaryUrl" target="_blank" class="btn btn-outline-primary">
              <i class="fa fa-fw fa-file-excel"></i>
              {{ trans('amilia_sales_summary') }}
            </a>
          </p>
        </b-col>
        <b-col>
          <p>
            <a :href="breakdownOfPaymentsUrl" target="_blank" class="btn btn-outline-primary">
              <i class="fa fa-fw fa-file-excel"></i>
              {{ trans('amilia_payments_breakdown') }}
            </a>
          </p>
          <p>
            <a :href="paymentsSummaryUrl" target="_blank" class="btn btn-outline-primary">
              <i class="fa fa-fw fa-file-excel"></i>
              {{ trans('amilia_payments_summary') }}
            </a>
          </p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  export default {
    props: [
      'slug',
      'start',
      'end',
      'size',
    ],
    data() {
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,
        lang: window.lang,

        error: null,
        showModal: false,
      }
    },
    computed: {
      paymentsSummaryUrl() {
        return `https://www.amilia.com/Reports/${this.lang}/${this.slug}/Reports/PaymentSummaryReport?From=${this.start}&To=${this.end}&Type=PaymentSummary`
      },
      breakdownOfPaymentsUrl() {
        return `https://www.amilia.com/Reports/${this.lang}/${this.slug}/Reports/PaymentPerAdminReport?From=${this.start}&To=${this.end}&Type=PaymentByAdmin`
      },
      salesSummaryUrl() {
        return `https://www.amilia.com/Reports/${this.lang}/${this.slug}/Reports/SalesSummaryReport?From=${this.start}&To=${this.end}&Type=SalesSummary`
      },
      beakdownOfSalesUrl() {
        return `https://www.amilia.com/Reports/${this.lang}/${this.slug}/Reports/BreakdownOfSalesReport?From=${this.start}&To=${this.end}&Type=BreakdownSales`
      },
    },
  }
</script>